'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';

import {projectModel} from "../../models/projectmodel.js";

export class ProjectsListCtrl extends ListCtrl
{
	storageNames = {
		query: 'ProjectsListCtrlQuery'
	};
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new projectModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
        if(col === 'starting_date_date'){
            return row.starting_date_date_string;
        }
        if(col === 'end_date_date'){
            return row.end_date_date_string;
        }

        if(row instanceof projectModel){
            return row.getValue(col);
        }
		return row[col];
	}
	
	getFooterData(col){
		if(typeof(this.columnsData.footer[col]) !== 'undefined'){
			switch(col){
				case 'requested_amount':
				case 'maximum_amount':
					return this.$filter('currency')(this.columnsData.footer[col].value);
			}
			return this.columnsData.footer[col].value;
		}
		return '';
	}
	
	exportList(){
		const query = new URLSearchParams({
			filters: JSON.stringify(this.query.filters),
			limit: this.query.limit,
			page: this.query.page,
			order: this.query.order,
		});
		
		const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');
		
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = `${this.cfgExportUrl}?${query.toString()}`;
		a.download = `Projects_${ts}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}


